import { useContext, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

import { getOptionById, SelectOption } from 'components/Select'
import { WorkspaceBidderContext } from 'features/globalSetup/contexts/WorkspaceBidderContext'
import { CommonForm } from 'features/globalSetup/forms/Prebid/Bidders/CommonForm'
import { useGetBiddersForSelect } from 'features/globalSetup/forms/Prebid/Bidders/sections/hooks/useGetBiddersForSelect'
import { BidderSlice } from 'features/globalSetup/forms/Prebid/Bidders/types'
import { Bidder } from 'features/globalSetup/types/bidder'
import { EditSchema } from './schemas/editSchema'

export const EditBidderFormBody = (): React.JSX.Element => {
  const { clearErrors, setValue, trigger, watch } = useFormContext<EditSchema>()
  const { workspaceBidder } = useContext(WorkspaceBidderContext)

  if (!workspaceBidder) {
    throw Error('Workspace Bidder should be accessible')
  }
  const workspaceBidderId: Bidder['id'] = workspaceBidder.bidder.id

  const { accountType, bidderCode } = watch()

  const bidders = useGetBiddersForSelect(accountType)

  const updateDefaults = (currentBidderId: Bidder['id']): void => {
    const bidder: SelectOption<BidderSlice> | undefined = bidders.find(
      (bidder: SelectOption<BidderSlice>) => bidder.value === currentBidderId,
    )
    if (!bidder?.rawData) return

    const { code, id }: BidderSlice = bidder.rawData

    const bidderSelectOption: SelectOption<BidderSlice> | undefined = getOptionById<BidderSlice>(
      id,
      bidders,
    )
    if (!bidderSelectOption) throw Error('Given Bidder ID does not match Bidders list')

    setValue('bidderCode', bidderCode || code)
    setValue('bidderId', bidderSelectOption)
    trigger('bidderId') // https://github.com/react-hook-form/react-hook-form/issues/2755
  }

  useEffect(() => {
    updateDefaults(workspaceBidderId)
    clearErrors() // clear errors before 'bidderSid' validation
  }, [workspaceBidderId, bidders])

  return (
    <CommonForm
      bidders={bidders}
      variant='edit'
    />
  )
}
